// extracted by mini-css-extract-plugin
export default {"total":"Table_total__oM3tn"};